function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 16v2H3v13a1 1 0 1 1-2 0V1a1 1 0 0 1 2 0v1h12.5A1.5 1.5 0 0 1 17 3.5V6h12.793a1.5 1.5 0 0 1 1.06 2.56L25.415 14l5.44 5.44A1.5 1.5 0 0 1 29.793 22H15a3 3 0 0 1-3-3V7.01a.995.995 0 0 1 .2-.61L14 4H3v12h7zm4-8v11a1 1 0 0 0 1 1h13.586l-4.94-4.94a1.5 1.5 0 0 1 0-2.12L28.586 8H14z"
});

var SvgReport = function SvgReport(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "cda7f264e624058b9115672c1f4a9999.svg";
export { SvgReport as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/report.svg
// module id = null
// module chunks = 